<div class="gallery-detail-container">
  <!-- Left Side: Image Gallery -->
  <div class="gallery-section">
    <!-- Main Image Display -->
    <div class="main-image-container">
      <img
        [src]="replaceBucket.replaceBucket(selectedImage.src)"
        [alt]="selectedImage.title"
        [title]="selectedImage.title"
        class="main-image"
        (click)="openDialogGallery(selectedImage.src)"
        (keydown)="openDialogGallery(selectedImage.src)"
        tabindex="0"
        loading="lazy"
      />
    </div>

    <!-- Thumbnail Navigation -->
    <div class="thumbnail-container">
      <div class="thumbnail-scroll">
        @for (image of images; track image.id; let i = $index) {
        <button
          class="thumbnail-item"
          [class.active]="i === selectedIndex"
          (click)="selectImage(image, i)"
          (keydown)="onThumbnailKeyDown($event, image, i)"
          [attr.aria-label]="'Select image ' + (i + 1) + ': ' + image.alt"
          type="button"
        >
          <img [src]="replaceBucket.replaceBucket(image.thumbnail || image.src)" [alt]="image.title" [title]="image.title" loading="lazy" />
        </button>
        }
      </div>
    </div>
  </div>

  <!-- Right Side: Content Details -->
  <div class="content-section">
    <div class="content-header header-with-badge">
      <h2 class="font-size-24 font-weight-bold title">{{ selectedImage.title }}</h2>
      @if(selectedImage.hot_badge_enable === 1) {
      <img
        src="assets/icons/icon-Fire.png"
        alt="ไอคอนสำหรับสินค้ายอดนิยม"
        title="ไอคอนสำหรับสินค้ายอดนิยม"
        class="hot-badge"
        loading="lazy"
      />
      }
    </div>
    <div class="content-body">
      <div class="description font-size-16" [innerHTML]="getSafeHtml(selectedImage.description || '')"></div>
    </div>
    <div class="action-buttons">
      @if (selectedImage.brand && selectedImage.product_id) {
      <a [routerLink]="['/products/1/model/detail/', selectedImage.product_id]" class="brand-button">
        <img src="assets/icons/icon-Tire.png" alt="ไอคอนสำหรับรุ่นยาง" title="ไอคอนสำหรับรุ่นยาง" loading="lazy" />
        <p>ยางรุ่น {{ selectedImage.brand }}</p>
      </a>
      } @if (selectedImage.service_center_id) {
      <a [routerLink]="['/branches/detail/', selectedImage.service_center_id]" class="details-button">
        <img src="assets/icons/icon-Store.png" alt="ไอคอนสำหรับศูนย์บริการ" title="ไอคอนสำหรับศูนย์บริการ" loading="lazy" />
        <p>{{ selectedImage.service_center_name }}</p>
      </a>
      }
    </div>
    <!-- <mat-icon>thumb_up</mat-icon> -->
    <div class="like-section">
      <button matButton (click)="toggleGalleryLike()" [class.liked]="isGalleryLiked">
        <img [src]="getGalleryLikeIcon()" alt="ไอคอนสำหรับถูกใจ" title="ไอคอนสำหรับถูกใจ" class="like-gallery" loading="lazy" />
      </button>
      <p class="font-size-16">{{ getGalleryLikeCount() }}</p>
    </div>
    <!-- Action Buttons -->

    <!-- Stats/Engagement -->
    <!-- @if (selectedImage.stats) {
    <div class="engagement-stats">
      <div class="stat-item">
        <mat-icon>thumb_up</mat-icon>
        <span>{{ selectedImage.stats.likes || 0 }}</span>
      </div>
    </div>
    } -->
  </div>
</div>
